import { useState, useEffect } from "react"

const filterEvents = (events, category) => {
  const now = new Date()

  return events?.edges?.reduce(
    (groups, { node }) => {
      if (category && node.category !== category) {
        return groups
      }

      // Use rawDate/rawEndDate if available (local YAML), otherwise use date/endDate (Contentful)
      const eventDate = node.rawDate || node.date
      const eventEndDate = node.rawEndDate || node.endDate

      if (new Date(eventEndDate || eventDate) < now) {
        groups.pastEvents.push(node)
      } else {
        groups.upcomingEvents.push(node)
      }

      return groups
    },
    { upcomingEvents: [], pastEvents: [] }
  )
}

export default function useEvents(allEvents = { edges: [] }, category) {
  const [events, setEvents] = useState(filterEvents(allEvents, category))

  useEffect(() => {
    setEvents(filterEvents(allEvents, category))
  }, [allEvents, category])

  return events
}
